// useContracts.js
import { useEffect, useState } from 'react';
import { apiGetUserContracts } from '../../Api/Contracts/Contracts';
import { apiGetMembers } from '../../Api/Profile/Profile';

const useContracts = () => {
  const [contracts, setContracts] = useState([]);
  const [user, setUser] = useState({});
  const [selectedContract, setSelectedContract] = useState(null);
  const [activeMenu, setActiveMenu] = useState('echeancier'); // State to track active menu

  const fetchContracts = async () => {
    const resp = await apiGetUserContracts();
    if (resp?.status === 200 && resp.data) {
      setContracts(resp.data);
    }
  };

  const fetchUser = async () => {
    const response = await apiGetMembers();
    if (response.status === 200) {
      setUser(response);
    } else {
      alert('Une erreur est survenue. Veuillez ré-essayer.');
    }
  };

  useEffect(() => {
    fetchUser();
    fetchContracts();
  }, []);

  const handleSelectContract = (contract) => {
    setSelectedContract(contract);
  };

  const handleDeselectContract = () => {
    setSelectedContract(null);
  };

  return {
    contracts,
    user,
    selectedContract,
    handleSelectContract,
    handleDeselectContract,
    activeMenu,
    setActiveMenu
  };
};

export default useContracts;
